
import './CSS/caracteresG11.scss';
//import schemaG0Haut from './Assets/table_caractère_g0-haut.svg';
//import schemaG0Bas from './Assets/table_caractère_g0-bas.svg';
import schemaG11HautPng from './Assets/table_caractère_g11-haut.png';
import schemaG11BasPng from './Assets/table_caractère_g11-bas.png';


export default function CaracteresG11()
{
    return (
        <div className='PageG11'>
            <div id='titre'>
                <h1>Jeu de caractères G11</h1>
            </div>
            <div id ="partie_haute">
                <img className="shemaG11scv" src={schemaG11HautPng} alt="table G11" />
            </div>
            <div id="partie_basse">
                <img  className="shemaG11scv" src={schemaG11BasPng} alt="table G11" />
            </div>
        </div>
    )
}